import React, { useState, useEffect } from 'react';
import EnhancedDialog from './EnhancedDialog';
import type { DeleteConfirmationDialogProps } from '../types/ui';

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  title,
  message,
  onConfirm,
  waitSeconds = 10,
  isDeleting = false
}) => {
  const [deleteCounter, setDeleteCounter] = useState<number>(waitSeconds);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    if (isOpen) {
      setDeleteCounter(waitSeconds);
      timer = setInterval(() => {
        setDeleteCounter((c: number) => {
          if (c <= 1) {
            if (timer) clearInterval(timer);
            return 0;
          }
          return c - 1;
        });
      }, 1000);
    }
    return () => { if (timer) clearInterval(timer); };
  }, [isOpen, waitSeconds]);

  return (
    <EnhancedDialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      canEscapeKeyClose={!isDeleting}
    >
      <div className="sky-dialog-body">
        {typeof message === 'string' ? <p>{message}</p> : message}
        <p>You must wait {waitSeconds} seconds before confirming this action.</p>
      </div>
      <div className="sky-dialog-footer">
        <button className="sky-btn sky-btn-ghost" onClick={onClose} disabled={isDeleting}>
          Cancel
        </button>
        <button
          className="sky-btn sky-btn-danger"
          onClick={onConfirm}
          disabled={deleteCounter > 0 || isDeleting}
        >
          {isDeleting ? (
            <span className="sky-spinner" style={{ width: 14, height: 14, borderWidth: 2 }} />
          ) : deleteCounter > 0 ? `Wait ${deleteCounter}s` : 'Confirm'}
        </button>
      </div>
    </EnhancedDialog>
  );
};

export default DeleteConfirmationDialog;
